import { BOOKING_CONFIRMATION_FLAG } from "./flags";

const capturedQuoteIds = new Set<string>();

/**
 * Records the booking-confirmation flag's exposure once per quote per page:
 * when the family books on the schedule-call station, in either arm, with
 * the variant their confirmation shows (a fail-open control reads as
 * control). Landing on an already-booked station is not an exposure.
 */
export function captureBookingConfirmationExposure(
  posthog: { capture: (event: string, properties: object) => unknown },
  quoteId: string,
  variant: "control" | "test",
): void {
  if (capturedQuoteIds.has(quoteId)) return;
  capturedQuoteIds.add(quoteId);
  posthog.capture("$feature_flag_called", {
    $feature_flag: BOOKING_CONFIRMATION_FLAG,
    $feature_flag_response: variant,
  });
}
